import { render } from "./BasicModal.vue?vue&type=template&id=78f21cc0&scoped=true&ts=true"
import script from "./BasicModal.vue?vue&type=script&lang=ts"
export * from "./BasicModal.vue?vue&type=script&lang=ts"

import "./BasicModal.vue?vue&type=style&index=0&id=78f21cc0&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/_vue_us_stage_azure_v24042026_02/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f21cc0"]])

export default __exports__